import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <nav className="bg-blue-900 text-white p-4 shadow-lg">
      <ul className="flex justify-around items-center list-none">
        <li>
          <Link to="/" className="text-white hover:text-orange-500 transition-colors duration-300 font-semibold">Inicio</Link>
        </li>
        <li>
          <Link to="/about" className="text-white hover:text-orange-500 transition-colors duration-300 font-semibold">Sobre Mí</Link>
        </li>
        <li>
          <Link to="/services" className="text-white hover:text-orange-500 transition-colors duration-300 font-semibold">Servicios</Link>
        </li>
        <li>
          <Link to="/contact" className="text-white hover:text-orange-500 transition-colors duration-300 font-semibold">Contacto</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Header;